import { useFetchHCaptchaToken } from "@faire/deprecated-retailer-visitor-shared/hooks/hCaptcha/useFetchHCaptchaToken";
import { hCaptchaQueryKey } from "@faire/deprecated-retailer-visitor-shared/lib/captchaUtils";
import { useHCaptchaStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/HCaptchaStore";
import login from "@faire/web-api--source/endpoints/www/api/v2/users/login/post";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { ILoginResponse } from "@faire/web-api--source/indigofair/data/ILoginResponse";
import { useQueryClient } from "@tanstack/react-query";

/**
 * Wrapper for fetchHCaptchaToken that also calls login endpoint with
 * the fetched hCaptcha token.
 *
 * @returns hCaptchaLogin(request: ILoginRequest): Promise<ILoginResponse>
 */
export const useHCaptchaLogin = () => {
  const { fetchHCaptchaToken } = useFetchHCaptchaToken();
  const queryClient = useQueryClient();
  const [{ widgetID }] = useHCaptchaStore(["widgetID"]);
  const queryKey = hCaptchaQueryKey(widgetID);

  const hCaptchaLogin = async (
    request: ILoginRequest
  ): Promise<ILoginResponse> => {
    await fetchHCaptchaToken(true);

    try {
      const loginResponse = await login({ ...request });
      return loginResponse;
    } catch (error) {
      // invalidate hCaptcha token if login fails
      await queryClient.invalidateQueries({ queryKey });
      return Promise.reject(error);
    }
  };

  return { hCaptchaLogin };
};
